import { AWAssetDto } from '@api/Api';
import Loader from '@components/Loader';
import { assetPreviewThumbnails } from '@helpers/assetPreviewThumbnails';
import { Tooltip } from 'antd';
import React, { memo, useMemo } from 'react';

type AssetsCellProps = {
  name: string;
  assets: AWAssetDto[];
};

function Asset({ asset }: { asset: AWAssetDto }) {
  const preparePreview = useMemo(() => {
    return assetPreviewThumbnails({
      url: asset?.previewUrl || '',
      status: 'ready',
      type: asset.type,
      size: 40,
      format: 'svg'
    });
  }, [asset]);

  return (
    <div className="assets-cell_asset">
      {preparePreview === 'pending' && (
        <Loader spinSize={40} isSpinning={true} />
      )}
      {preparePreview !== 'pending' && typeof preparePreview === 'string' ? (
        <img src={preparePreview || ''} alt="" />
      ) : (
        preparePreview
      )}
    </div>
  );
}

export default memo(function AssetsCell({ assets, name }: AssetsCellProps) {
  const _assets = assets.slice(0, 2);
  const assetCountLeft = assets.length - 2;
  return (
    <div className="assets-cell">
      <div className="assets-cell_items">
        {assetCountLeft > 0 && (
          <div className="assets-cell_count">+{assetCountLeft}</div>
        )}
        {_assets.map((asset) => (
          <Asset key={asset.id} asset={asset} />
        ))}
      </div>
      <Tooltip
        title={name}
        className="name"
        overlayClassName="toggle_favorite_overlay"
      >
        {name}
      </Tooltip>
    </div>
  );
});
